/**
 * Backend types for all health solutions
 */
export const BENEFIT = 'benefit';
export const HEALTH_PROGRAM = 'health_program';
export const LIFEMARKET = 'lifemarket';
export const HEALTH_CONTENT = 'health_content';
export const CARE_TEAM = 'care_team';
